import React from 'react'

const IceHockey = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 25 24' version='1.1'>
      <title>IceHockey</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-506.000000, -731.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-4' transform='translate(465.000000, 707.000000)'>
            <g id='icon/16/sport/hockey/hockey' transform='translate(41.000000, 24.089286)'>
              <path
                d='M14.25,21 L14.25,23.25 L9.75,23.25 L9.75,21 L14.25,21 Z M22.5,0.75 L24,2.25 L7.5,18.75 L0,18.75 L0.00636472245,14.625 L8.63136472,14.625 L22.5,0.75 Z M14.6205544,13.875 L15.3813647,14.625 L24.0063647,14.625 L24,18.75 L16.5,18.75 L13.125,15.375 L14.6205544,13.875 Z M1.69872456,0.961163966 L10.8687803,10.1312197 L9.37324946,11.6267505 L0.203193719,2.45669481 L1.69872456,0.961163966 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IceHockey
